import React from 'react';
import { GridContainer, LeftSideBar, CenterContent, RightSideBar } from 'global/components/perform-grid';
import { useScreen } from 'global/styles';
import Create from './create';

/** Create user form sits in the center grid column (empty side panels). */
export default (props) => {
  const { isMobile } = useScreen();

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile} />
      <CenterContent>
        <Create />
      </CenterContent>
      <RightSideBar />
    </GridContainer>
  );
};
